module.exports = __webpack_public_path__ + "files/690af5ea55e9bdfcc780529a14ece88b.svg";